export const colorWhite = '#FFF';
export const colorBlue = '#0099CC';
export const colorLightGray = '#DDD';
